import React from "react";
import "../styles/connectCalenderModal.css";
import calendarHeart from "../assets/icons/calendarHeart.svg";
import close from "../assets/icons/close.svg";
import { getText, TextId } from "./Util/TextHelper";
import ConnectCalenderButton from "./ConnectCalenderButton";
const ConnectCalenderModal = ({ onClose }) => {
  return (
    <div className="cal-wrapper">
      <div className="cal-container custom-gradient-border ">
        <div className="cal-close-container">
          <div className="cal-close" onClick={() => onClose()}>
            <img src={close} alt="close" />
          </div>
        </div>
        <div className="cal-content">
          <div>
            <span>
              <img src={calendarHeart} alt="calender-heart" />
            </span>
          </div>
          <div className="cal-message">
            <span className="cal-message-label">
              {getText(TextId.calenderModalTitle)}
            </span>
            <span className="cal-message-info">
              {getText(TextId.calenderModalInfo)}
            </span>
          </div>
          <ConnectCalenderButton />
        </div>
      </div>
    </div>
  );
};

export default ConnectCalenderModal;
